module.exports = __webpack_public_path__ + "img/glitter_3.c45ed0ec.jpg";